import { ErrorMessageEn } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CompanyBuilder,
  CompanySettings,
  UpdateCompanySettingsInput,
} from '../companies.types';

export const updateCompanySettings = (builder: CompanyBuilder) =>
  builder.mutation<CompanySettings, UpdateCompanySettingsInput>({
    query: ({ companyId, ...settings }) => ({
      url: `/companies/${companyId}/settings`,
      method: 'PUT',
      body: settings,
    }),
    transformErrorResponse: (error) => {
      errorHandler(
        '[updateCompanySettings]',
        ErrorMessageEn.UpdateCompany,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (_result, _error, { companyId }) => [
      { type: 'Company', id: `settings-${companyId}` },
    ],
  });
